import { IFileWithStatus } from '@insync-students-constants/files/files.enum';
import { createContext } from 'react';
export interface UploadContextType {
  retrieveUploadedFiles(id: string): IFileWithStatus[];
  storeUploadedFiles(id: string, updatedUploadedFiles: IFileWithStatus[]): void;
}
export const UploadContext = createContext<UploadContextType>(null);